import { motion } from "framer-motion";

export const ease = [0.16, 1, 0.3, 1];

export default function Reveal({ children, delay = 0, y = 32, className = "", amount = 0.15 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount }}
      transition={{ duration: 0.9, delay, ease }}
    >
      {children}
    </motion.div>
  );
}

export function SectionLabel({ n, children, light = false }) {
  return (
    <Reveal>
      <p
        className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.32em] ${
          light ? "text-sun" : "text-terra"
        }`}
      >
        <span className={`font-display italic text-base tracking-normal ${light ? "text-sun/70" : "text-terra/60"}`}>
          ({n})
        </span>
        {children}
        <span className={`h-px flex-1 ${light ? "bg-cream/20" : "bg-olive/20"}`} />
      </p>
    </Reveal>
  );
}
